/**
 * Partner activation shortcodes an admin puts in a link's URL instead of a real address, e.g.
 * `https://[meso-core]/`. The LMS swaps them, on click, for a freshly minted sign-in link from our
 * backend (MVP-gated there). Used by the manual link handlers (useMesoHandoff,
 * useCoachesOnlineHandoff) and by the bonus cards' unlock URL.
 */

export const COACHESONLINE_MVP_SHORTCODE = '[coachesonline-mvp]';
export const MESO_MVP_SHORTCODE = '[meso-core]';

// Match the core token regardless of how the editor stores/encodes the URL, e.g.
// `[coachesonline-mvp]`, `coachesonline-mvp`, `https://coachesonline-mvp`, `%5Bcoachesonline-mvp%5D`.
const COACHESONLINE_TOKEN = 'coachesonline-mvp';

// Match common authoring variants: `[meso-core]`, `meso-core`, `[meso-mvp]`, `meso-mvp`, `[meso]`.
// A bare `meso` is deliberately NOT matched: it would hijack ordinary training links ("mesocycle").
// The pre-rename `stride` tokens stay so manuals authored before the rename keep working.
const MESO_TOKENS = ['meso-core', 'meso-mvp', '[meso]', 'stride-core', 'stride-mvp', 'stride'];

export const urlHasCoachesOnlineShortcode = (url: string): boolean => url.toLowerCase().includes(COACHESONLINE_TOKEN);

export const urlHasMesoShortcode = (url: string): boolean => {
  const value = url.toLowerCase();

  return MESO_TOKENS.some((token) => value.includes(token));
};
